enum RiskProfileCode {
    SAFE = 'RISKPROFILECD01',
    STABLE = 'RISKPROFILECD02',
    BALANCED = 'RISKPROFILECD03',
    DYNAMIC = 'RISKPROFILECD04',
    OFFENSIVE = 'RISKPROFILECD05',
    UNDEFINED = 'UNDEFINED'
}

export default RiskProfileCode;
